import { render, staticRenderFns } from "./QuickbooksOauth2Callback.vue?vue&type=template&id=06b12b3e"
import script from "./QuickbooksOauth2Callback.vue?vue&type=script&lang=ts"
export * from "./QuickbooksOauth2Callback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports